import React from 'react';
import ReceptionVisitHistoryPanel from '../../receptionist/panels/ReceptionVisitHistoryPanel';
import { NursePageHeader } from '../ui';
import { useNurseWorkspace } from '../nurseWorkspaceContext';
export default function NurseVisitsHistoryPage() {
  const { toast, copy } = useNurseWorkspace();
  const H = copy.VISIT_HISTORY;

  return (
    <div className="nr-history recv-dash-pro--main">
      <NursePageHeader
        badge={H.PAGE_BADGE}
        title={H.PAGE_TITLE}
        description={H.PAGE_SUBTITLE}
      />
      <ReceptionVisitHistoryPanel
        toast={toast}
        panelTitle={H.PANEL_TITLE}
        panelSubtitle={H.PANEL_SUBTITLE}
        defaultServiceLine="NURSING"
        lockServiceLine
        hidePanelHeader
      />
    </div>
  );
}
